import React, { useState } from 'react';
import LocalPostOfficeOutlinedIcon from '@mui/icons-material/LocalPostOfficeOutlined';
import { Button, Col, Form, Row, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { usePageTitle } from '../../../../App';
import datagain_home_page_hero_img from '../../../../assets/images/datagain-home-page-hero-img.png';
import logo from '../../../../assets/images/logo.svg';
import { LOGIN_ROUTE } from '../../../../constants/RouteNameConstants';
import { forgotPasswordRequest } from '../actions';

function ForgotPassword() {
  usePageTitle('Datagain Transcription  - Forgot Password'); // Set tab title

  const [emailData, setEmailData] = useState('');
  const dispatch = useDispatch();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (emailData) {
      dispatch(forgotPasswordRequest({ email: emailData }));
    }
  };

  const handleEmailChange = (e) => {
    setEmailData(e.target.value);
  };

  let forgotPasswordData = useSelector((state) => state?.forgotPasswordData?.user?.data?.statusCode);

  // Page in loading
  let loading = useSelector((state) => state?.forgotPasswordData?.loading);

  return (
    <div className="d-flex vh-100 w-100 flex-column overflow-y-auto bg-lighter">
      <div className="d-flex flex-grow-1 align-items-center justify-content-center py-4">
        <div className="login-card shadow-sm">
          <div className="form-group mb-5">
            <div className="mb-3 text-center">
              <Link to={LOGIN_ROUTE} >
                <img src={logo} alt="logo" className="img-fluid logo-img" />
              </Link>
            </div>
            <div className="text-center">
              <h1 className="form-title text-center mb-0">Forgot Password?</h1>
              {forgotPasswordData !== 200 && (
                <p className="font-weight-normal opacity-50">Enter your email address to reset your password.</p>
              )}
            </div>
            <div>
              {forgotPasswordData === 200 ? (
                <h1 className="form-title">An email with instructions has been sent to your email address.</h1>
              ) : (
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md="12">
                    <label className="form-label fnt-14 fw-normal">Email</label>
                      <Form.Group className="mb-3 position-relative" controlId="exampleForm.ControlEmail">
                        <Form.Control
                          id="Email"
                          type="email"
                          placeholder="Enter email address"
                          value={emailData}
                          onChange={handleEmailChange}
                          autoComplete="nope"
                          data-lpignore="true"
                          required
                        />
                        <div className="input-group-icon">
                          <LocalPostOfficeOutlinedIcon />
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                  <div className="mt-2 text-end fnt-14">
                    <Link to={LOGIN_ROUTE} className="link-color">
                      Got to Login
                    </Link>
                  </div>
                  <div className="d-grid gap-2 mt-3">
                    <Button
                      type="submit"
                    
                      size="lg"
                      className="btn btn-primary"
                      disabled={!emailData || loading}
                    >
                      {loading ? (
                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                      ) : (
                        'Submit'
                      )}
                    </Button>
                  </div>
                </Form>
              )}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
